/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.SavedSearches";
        class SavedSearchesWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("SavedSearchesWidgetTypeClass.createInstance()");
                    return new SavedSearchesWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("SavedSearchesWidgetTypeClass._storeHtml()");
                    SavedSearchesWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SavedSearchesWidgetTypeClass::constructor");
                if (SavedSearchesWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/SavedSearches/saved-searches.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.SavedSearchesWidgetTypeClass = SavedSearchesWidgetTypeClass;
        class SavedSearchesWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._componentContainer = null;
                this._activateAsPrimary = true;
                this._activateAsRelated = false;
                this._lastSelectedItem = null;
                this._refreshTriggers = null;
                this._ssComponent = null;
                this.presentInstance = () => {
                    this._log.info("SavedSearchesWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = SavedSearchesWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._componentContainer = this._container.querySelector('#savedSearchesComponentContainer');
                    this._widgets.setTitle(this._config, this._container.querySelector('#savedSearchesWidgetHeadingText'), 'STR_WPT_SAVED_SEARCHES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    let componentConf = {};
                    this._ssComponent = new Widgets.ComponentSavedSearch(this._core, this._componentContainer, this, componentConf);
                    this._ssComponent.ErrorCallback = this._callErrorHandler;
                    this._ssComponent.FailCallback = this._callFailedHandler;
                    this._ssComponent.SearchSelectedCallBack = this._searchClicked;
                    this._container.querySelector('#savedSearchesReload').addEventListener('click', this._refresh);
                    this._ssComponent.present();
                    this._refresh();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("SavedSearchesWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("SavedSearchesWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._refresh = () => {
                    this._log.info("SavedSearchesWidgetInstanceClass._refresh()");
                    this._ssComponent.refresh();
                };
                this._searchClicked = (search) => {
                    this._log.info("SavedSearchesWidgetInstanceClass._searchClicked()");
                    let requestSearch = { SearchDefinition: search };
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._searchExecuted.bind(this, search), {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._searchExecuted = (search, response) => {
                    this._log.info("SavedSearchesWidgetInstanceClass._searchExecuted()");
                    let config = this._config;
                    // Activation type - could be one of three options
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = response.Documents;
                    navEvent.AdditionalContext['FlexSearch'] = search;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "SavedSearches";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.returnedToHomepage = () => {
                    this._log.info("SavedSearchesWidgetInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SavedSearchesWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (config.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                    this._refreshTriggers = conf.RefreshTriggers;
                else
                    this._refreshTriggers = [];
                this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
            }
            activate(context) {
                this._log.info("SavedSearchesWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.FAVOURITE_ADDED:
                        this._refresh();
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._refresh();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                            break;
                        }
                }
            }
        }
        SavedSearchesWidgetInstanceClass.HtmlData = null;
        Widgets.SavedSearchesWidgetInstanceClass = SavedSearchesWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
